import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RouteParamsService } from 'app/shared/service/route-params.service';

import { ChartViewModalComponent } from './chart-view-modal/chart-view-modal.component';

@Component({
  selector: 'cc-chart-view',
  templateUrl: './chart-view.component.html',
  styleUrls: ['./chart-view.component.scss'],
})
export class ChartViewComponent implements OnInit, OnDestroy {
  private unSubscribe = new Subject<void>();
  private modalRef;

  constructor(
    private readonly modalService: NgbModal,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly routeParamsService: RouteParamsService,
  ) {}

  ngOnInit() {
    combineLatest([
      this.route.params,
      this.routeParamsService.get('dashboard'),
      this.routeParamsService.get('company'),
      this.routeParamsService.get('project'),
      this.routeParamsService.get('team'),
    ])
      .pipe(takeUntil(this.unSubscribe))
      .subscribe(([params, dashboard, company, project, team]) => {
        this.openChartModal(
          params.teamId,
          params.companyId,
          params.dashboardId,
          params.chartId,
          company,
          project,
          team,
          dashboard,
        );
      });
  }

  private openChartModal(teamId, companyId, dashboardId, chartId, company, project, team, dashboard) {
    if (!this.modalService.hasOpenModals() && !this.modalRef) {
      this.modalRef = this.modalService.open(ChartViewModalComponent, {
        backdrop: 'static',
        windowClass: 'add-edit-modal',
      });

      void this.modalRef.result
        .then(() => {
          this.goBack();
          return true;
        })
        .catch(() => {
          this.goBack();
        });
    }

    this.modalRef.componentInstance.company = company;
    this.modalRef.componentInstance.project = project;
    this.modalRef.componentInstance.team = team;
    this.modalRef.componentInstance.teamId = teamId;
    this.modalRef.componentInstance.companyId = companyId;
    this.modalRef.componentInstance.dashboardId = dashboardId;
    this.modalRef.componentInstance.chartId = chartId;
    this.modalRef.componentInstance.dashboard = dashboard;
  }

  private goBack(reload = true) {
    void this.router.navigate(['..'], { relativeTo: this.route, state: { reload } });
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
